import { render, staticRenderFns } from "./ComplaintAllInfo.vue?vue&type=template&id=7df21c5f&"
import script from "./ComplaintAllInfo.vue?vue&type=script&lang=js&"
export * from "./ComplaintAllInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports